module.exports = __webpack_public_path__ + "img/whats-new-53-hero_16x9_cn_poster.a338eca.jpg";